/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendD9KpiResponseDto } from '../models/backend-d-9-kpi-response-dto';
import { BackendD9TableResponseDto } from '../models/backend-d-9-table-response-dto';
import { BackendD9TimeseriesResponseDto } from '../models/backend-d-9-timeseries-response-dto';
import { getKpiDashboardsD9KpiGet } from '../fn/dashboards/get-kpi-dashboards-d-9-kpi-get';
import { GetKpiDashboardsD9KpiGet$Params } from '../fn/dashboards/get-kpi-dashboards-d-9-kpi-get';
import { getTableDashboardsD9TableGet } from '../fn/dashboards/get-table-dashboards-d-9-table-get';
import { GetTableDashboardsD9TableGet$Params } from '../fn/dashboards/get-table-dashboards-d-9-table-get';
import { getTimeseriesDashboardsD9TimeseriesGet } from '../fn/dashboards/get-timeseries-dashboards-d-9-timeseries-get';
import { GetTimeseriesDashboardsD9TimeseriesGet$Params } from '../fn/dashboards/get-timeseries-dashboards-d-9-timeseries-get';

@Injectable({ providedIn: 'root' })
export class BackendApiD9Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getKpiDashboardsD9KpiGet()` */
  static readonly GetKpiDashboardsD9KpiGetPath = '/dashboards/d9/kpi';

  /**
   * D9 KPI: revenue, gross_profit (главное), gross_margin, ebitda, net_profit за период.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKpiDashboardsD9KpiGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpiDashboardsD9KpiGet$Response(
    params: GetKpiDashboardsD9KpiGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD9KpiResponseDto>> {
    return getKpiDashboardsD9KpiGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 KPI: revenue, gross_profit (главное), gross_margin, ebitda, net_profit за период.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getKpiDashboardsD9KpiGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpiDashboardsD9KpiGet(
    params: GetKpiDashboardsD9KpiGet$Params,
    context?: HttpContext,
  ): Observable<BackendD9KpiResponseDto> {
    return this.getKpiDashboardsD9KpiGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD9KpiResponseDto>): BackendD9KpiResponseDto => r.body),
    );
  }

  /** Path part for operation `getTimeseriesDashboardsD9TimeseriesGet()` */
  static readonly GetTimeseriesDashboardsD9TimeseriesGetPath = '/dashboards/d9/timeseries';

  /**
   * D9 временной ряд по выбранной гранулярности.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeseriesDashboardsD9TimeseriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesDashboardsD9TimeseriesGet$Response(
    params: GetTimeseriesDashboardsD9TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD9TimeseriesResponseDto>> {
    return getTimeseriesDashboardsD9TimeseriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 временной ряд по выбранной гранулярности.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeseriesDashboardsD9TimeseriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesDashboardsD9TimeseriesGet(
    params: GetTimeseriesDashboardsD9TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BackendD9TimeseriesResponseDto> {
    return this.getTimeseriesDashboardsD9TimeseriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD9TimeseriesResponseDto>): BackendD9TimeseriesResponseDto => r.body),
    );
  }

  /** Path part for operation `getTableDashboardsD9TableGet()` */
  static readonly GetTableDashboardsD9TableGetPath = '/dashboards/d9/table';

  /**
   * D9 таблица P&L по выбранной гранулярности.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTableDashboardsD9TableGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableDashboardsD9TableGet$Response(
    params: GetTableDashboardsD9TableGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD9TableResponseDto>> {
    return getTableDashboardsD9TableGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 таблица P&L по выбранной гранулярности.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTableDashboardsD9TableGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableDashboardsD9TableGet(
    params: GetTableDashboardsD9TableGet$Params,
    context?: HttpContext,
  ): Observable<BackendD9TableResponseDto> {
    return this.getTableDashboardsD9TableGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD9TableResponseDto>): BackendD9TableResponseDto => r.body),
    );
  }
}
